import styled from 'styled-components';
import { Colors } from '../../../colors';
export const Container = styled.div `
  padding: 8px 16px 4px;
  font-size: 12px;
  color: ${Colors.GS600};
`;
